import { render, staticRenderFns } from "./pockets.vue?vue&type=template&id=c74297c6&"
import script from "./pockets.vue?vue&type=script&lang=js&"
export * from "./pockets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports